const localStorageHelper = {
    getItem(key) {
        try {
            const value = window.localStorage.getItem(key);
            const ngValue = window.localStorage.getItem(`ng2-webstorage|${key}`);
            const returnValue = value || ngValue;
            return JSON.parse(returnValue);
        } catch (err) {
            console.log(err);
            return null;
        }
    },
    setItem(key, value) {
        try {
            window.localStorage.setItem(key, JSON.stringify(value || null));
        } catch (err) {
            console.log(err);
        }
    },
    removeItem(key) {
        try {
            window.localStorage.removeItem(key);
        } catch (err) {
            console.log(err);
        }
    }
};

export default localStorageHelper;
